import { useMemo } from "react";
import { Navigate } from "react-router";

import { useFeatureFlag } from "@vega-api/extended/auth/useFeatureFlag";
import { TabNavigation } from "@vega-core/components/Layout/TabNavigation";
import { type Tab } from "@vega-core/models/core.type";
import { m } from "@vega-core/paraglide/messages";
import { GPSettingsFullPaths } from "@vega-modules/paths";
import { SettingsSectionLayout } from "@vega-modules/scenes/Settings/components/SettingsSectionLayout";

import { CategoriesSettingsCard } from "../components/CategoriesSettingsCard/CategoriesSettingsCard";
import { DefaultTriageSlaCard } from "../components/DefaultTriageSlaCard/DefaultTriageSlaCard";

export const CaseManagementPage = () => {
  const { featureFlag } = useFeatureFlag();

  const tabs: Tab[] = useMemo(
    () => [
      {
        index: "categories",
        title: m.settings_caseManagement_categoriesTab(),
        component: <CategoriesSettingsCard />,
      },
      {
        index: "sla",
        title: m.settings_caseManagement_slaTab(),
        component: <DefaultTriageSlaCard />,
      },
    ],
    [],
  );

  if (!featureFlag.gp_case_management) {
    return <Navigate replace to={GPSettingsFullPaths.SettingsCollaborators} />;
  }

  return (
    <SettingsSectionLayout
      description={m.settings_caseManagement_description()}
      title={m.settings_caseManagement_title()}
    >
      <TabNavigation
        innerGap={false}
        noMargin
        noSingleTab={false}
        tabs={tabs}
        transparentBG
      />
    </SettingsSectionLayout>
  );
};
